import React from "react";
// React router dom
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// Router
import { MainPageRouter, DashboardRouter } from "routers";
// Theme provider
import { ThemeProvider } from "styled-components";
// utils
import { mainTheme } from "utils";
// Login screen
import LoginScreen from "screens/LoginScreen";
// Styles
import "./App.scss";
// Toast alert
import { ToastAlert } from "components";
// React helmet async
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <Router>
      <HelmetProvider>
        <ToastAlert />
        <ThemeProvider theme={mainTheme}>
          <Switch>
            <Route
              path="/login"
              render={(props) => <LoginScreen {...props} />}
            />
            <Route
              path="/dashboard"
              name="Dashboard"
              render={(props) => <DashboardRouter {...props} />}
            />
            <Route
              path="/"
              name="MainPage"
              render={(props) => <MainPageRouter {...props} />}
            />
          </Switch>
        </ThemeProvider>
      </HelmetProvider>
    </Router>
  );
}

export default App;
